import z from 'zod';

export const CheckCurationCreatableServiceResponseSchema = z.object({
  isCreatable: z.boolean(),
});

export type CheckCurationCreatableServiceResponse = z.infer<
  typeof CheckCurationCreatableServiceResponseSchema
>;
